import { combineReducers } from 'redux';

import notificationLetters from './letter/reducer';

export default combineReducers({
  notificationLetters,
});



// WEBPACK FOOTER //
// ./src/pages/notificationanddirectcertifiedletters/state/reducer.js